// extracted by mini-css-extract-plugin
export default {"container":"carditem_container__JYE7F","card":"carditem_card__58mLH","label":"carditem_label__-cyP7","cost":"carditem_cost__VaKt1"};